import { UPLOAD_LAB_ORDER_RESULT } from './../actions/upload';

const initialState = {
    upload_lab_order_result_waiting : false,
    upload_lab_order_result_success : {},
    upload_lab_order_result_error :{},
};

export default function upload(state = initialState, action){
    switch (action.type){
        case UPLOAD_LAB_ORDER_RESULT:
            return {
                ...state,
                upload_lab_order_result_waiting : action.upload_lab_order_result_waiting,
                upload_lab_order_result_success : action.upload_lab_order_result_response,
                upload_lab_order_result_error : action.upload_lab_order_result_error
            }
        default:
            return state;
    }
}